import { Box, Button, Typography } from "@material-ui/core";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LinkIcon from "@mui/icons-material/Link";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  getFileNameFromUrl,
  isImageUrl,
  isPdfUrl,
  isVideoUrl,
} from "../utils/file-helpers";

function renderPreview(url) {
  if (isImageUrl(url)) {
    return (
      <Box
        component="img"
        src={url}
        alt="Arquivo vinculado"
        style={{
          width: 72,
          height: 72,
          objectFit: "cover",
          borderRadius: 6,
          flexShrink: 0,
          border: "1px solid #e9ecef",
        }}
      />
    );
  }

  if (isVideoUrl(url)) {
    return (
      <Box
        style={{
          width: 72,
          height: 72,
          borderRadius: 6,
          flexShrink: 0,
          overflow: "hidden",
          border: "1px solid #e9ecef",
          backgroundColor: "#000",
        }}
      >
        <video
          src={url}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          muted
          playsInline
        />
      </Box>
    );
  }

  const iconStyle = { fontSize: 36, color: "#8898aa" };

  if (isPdfUrl(url)) {
    return (
      <Box
        style={{
          width: 72,
          height: 72,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 6,
          backgroundColor: "#f6f9fc",
          flexShrink: 0,
        }}
      >
        <PictureAsPdfIcon style={iconStyle} />
      </Box>
    );
  }

  return (
    <Box
      style={{
        width: 72,
        height: 72,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 6,
        backgroundColor: "#f6f9fc",
        flexShrink: 0,
      }}
    >
      <InsertDriveFileIcon style={iconStyle} />
    </Box>
  );
}

export default function ExistingLinkedFile({
  url,
  label = "Arquivo atual vinculado",
  openLabel = "Abrir arquivo",
  hidden = false,
  helperText = "Selecione um novo arquivo apenas se quiser substituí-lo.",
  variant = "file",
}) {
  if (!url?.trim() || hidden) return null;

  const fileName = variant === "link" ? url.trim() : getFileNameFromUrl(url);

  return (
    <Box
      marginTop={1}
      padding={1.5}
      style={{
        backgroundColor: themeColorsDesingSystem.stone?.light || "#f6f9fc",
        borderRadius: 8,
        border: "1px solid #dee2e6",
      }}
    >
      <Box display="flex" alignItems="flex-start" style={{ gap: 12 }}>
        {variant === "link" ? (
          <Box
            style={{
              width: 72,
              height: 72,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 6,
              backgroundColor: "#fff",
              flexShrink: 0,
              border: "1px solid #e9ecef",
            }}
          >
            <LinkIcon style={{ fontSize: 36, color: "#8898aa" }} />
          </Box>
        ) : (
          renderPreview(url)
        )}
        <Box flex={1} minWidth={0}>
          <Typography variant="body2" style={{ fontWeight: 600 }}>
            {label}
          </Typography>
          <Typography
            variant="caption"
            style={{
              color: themeColorsDesingSystem.gray.dark,
              wordBreak: "break-all",
              display: "block",
            }}
          >
            {fileName}
          </Typography>
          {helperText && (
            <Typography
              variant="caption"
              style={{
                color: themeColorsDesingSystem.gray.dark,
                display: "block",
                marginTop: 4,
              }}
            >
              {helperText}
            </Typography>
          )}
        </Box>
      </Box>
      <Box marginTop={1.5}>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          component="a"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          startIcon={<LinkIcon />}
        >
          {openLabel}
        </Button>
      </Box>
    </Box>
  );
}
